import SectionHeading from "@/components/base/SectionHeading";
import { hotSeries } from "@/mocks/content";

export default function HotSeries() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-50">
      <SectionHeading
        id="series"
        eyebrow="Trending Series"
        title="热播剧集：讨论度较高的连续剧"
        description="剧集与电影最大的不同在于节奏与篇幅。下面这些作品在讨论度和观看时长上各有特点，适合想跟着热点追剧、或想找一部能长期投入的连续剧的用户。"
      />

      <div className="mt-10 md:mt-12 rounded-lg border border-background-200 overflow-hidden">
        {hotSeries.map((item, index) => (
          <div
            key={item.id}
            className="group flex flex-col md:flex-row md:items-center gap-4 md:gap-6 p-5 md:p-6 border-b border-background-200 last:border-b-0 bg-background-50 transition-colors hover:bg-primary-50"
          >
            <div className="flex items-center gap-4 md:gap-5 md:w-72 shrink-0">
              <span className="w-10 h-10 shrink-0 rounded-md bg-background-100 text-secondary-700 font-heading font-bold flex items-center justify-center">
                {String(index + 1).padStart(2, "0")}
              </span>
              <div>
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950">{item.title}</h3>
                <p className="mt-1 text-xs text-foreground-500">
                  {item.year} · {item.region}
                </p>
              </div>
            </div>

            <div className="flex flex-wrap items-center gap-2 md:w-52 shrink-0">
              <span className="px-2.5 py-1 rounded-full bg-accent-100 text-accent-800 text-[11px]">{item.tag}</span>
              <span className="px-2.5 py-1 rounded-full bg-background-200 text-foreground-700 text-[11px]">
                {item.episodes}
              </span>
            </div>

            <p className="text-sm leading-7 text-foreground-600 flex-1">{item.desc}</p>
          </div>
        ))}
      </div>

      <div className="mt-6 flex items-start gap-3 rounded-lg bg-secondary-50 border border-secondary-200 p-4 md:p-5">
        <span className="w-9 h-9 shrink-0 rounded-md bg-secondary-100 text-secondary-800 flex items-center justify-center">
          <i className="ri-lightbulb-line"></i>
        </span>
        <p className="text-sm leading-7 text-foreground-700">
          追剧前可以先看「集数」与「类型」：短集数适合连续几天看完，多季长线作品更适合有时间慢慢投入的观看方式。
        </p>
      </div>
    </section>
  );
}